import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function SmartPhone(props) {
    return (
        <SvgIcon {...props}>
            <path d="M5.142,2H0.859C0.386,2,0,2.383,0,2.853v9.295C0,12.616,0.386,13,0.859,13h4.282 C5.614,13,6,12.616,6,12.147V2.853C6,2.383,5.614,2,5.142,2z M2.53,3.021h0.94c0.055,0,0.101,0.044,0.101,0.1 c0,0.055-0.046,0.1-0.101,0.1H2.53c-0.055,0-0.101-0.045-0.101-0.1C2.43,3.065,2.475,3.021,2.53,3.021z M3,12.47 c-0.248,0-0.447-0.199-0.447-0.443c0-0.245,0.2-0.444,0.447-0.444c0.247,0,0.447,0.199,0.447,0.444 C3.448,12.271,3.248,12.47,3,12.47z M5.427,11.21H0.572V3.887h4.855V11.21z" />
        </SvgIcon>
    );
}

SmartPhone.defaultProps = {
    viewBox: '0 0 6 16'
};

export default SmartPhone;
